module.exports = __webpack_public_path__ + "static/media/Content server - GBR network 21-03-2025 C.894134f6.png";